// Camada fina sobre o gtag do GA4. Quando o analytics está desligado
// (dev/test, ou GA4_MEASUREMENT_ID ausente) vira no-op silencioso.

declare global {
  interface Window {
    gtag?: (command: string, ...args: unknown[]) => void
  }
}

export type EventParams = Record<string, string | number | boolean | null | undefined>

export function track(event: string, params: EventParams = {}): void {
  window.gtag?.("event", event, params)
}
